import type { LucideIcon } from 'lucide-react';

interface StatCounterProps {
  icon: LucideIcon;
  label: string;
  value: number | string;
  tone?: 'cyan' | 'green' | 'amber' | 'red' | 'muted';
}

const toneColors: Record<string, string> = {
  cyan: 'var(--brand)',
  green: '#3fb950',
  amber: '#d29922',
  red: '#f85149',
  muted: '#8b949e',
};

export default function StatCounter({ icon: Icon, label, value, tone = 'cyan' }: StatCounterProps) {
  const color = toneColors[tone] || toneColors.cyan;
  return (
    <div className="stat-counter">
      <Icon size={12} style={{ color }} />
      <div className="stat-counter-body">
        <div className="stat-counter-label">{label}</div>
        <div className="stat-counter-value" style={{ color }}>
          {typeof value === 'number' ? String(value).padStart(3, '0') : value}
        </div>
      </div>
    </div>
  );
}
